
const appColors = {
  ColorA: '#CAD488',
  ColorB: '#96CF8F',
  ColorC: '#A7D4C9',
  ColorD: '#A3A9DB',
  ColorE: '#bcb586',
  ColorF: '#565B84',
  ColorG: '#b29bc3',
  ColorNa: '#8a0b2d',
  ColorAz: '#e7c8e7',
  ColorBack: '#041427',
  ColorBack1: '#202552',
  ColorBack2: '#6666A4',
  ColorOp1: 'rgba(230, 241, 74, 0.3)',
  ColorX: '#0B1249',
  ColorScroll: '#E6F14A',
  ColorScroll2: '#C7EDE4',
  ColorG2: '#A2BAE8',
  ColorNB: '#6b5d98',
};

export default appColors;
